export const INDEX = `{
  news(
    first: 4,
    where: {
      orderby: {
        field: DATE,
        order: DESC
      }
    }
  ) {
    nodes {
      id
      databaseId
      slug
      date
      title(format: RENDERED)
      featuredImage {
        node {
          sourceUrl
          mediaDetails {
            sizes {
              sourceUrl
              name
            }
          }
        }
      }
    }
  }

  stocks(
    first: 200,
    where: {
      orderby: {
        field: DATE,
        order: DESC
      },
      metaQuery: {
        metaArray: {
          key: "sold",
          value: "0"
        }
      }
    }
  ) {
    nodes {
      id
      databaseId
      slug
      date
      title(format: RENDERED)
      carCategories {
        nodes {
          slug
          name
        }
      }
      makers {
        nodes {
          slug
          name
        }
      }
      acf {
        carImage {
          sourceUrl
          mediaDetails {
            sizes {
              sourceUrl
              name
            }
          }
        }
        image1 {
          sourceUrl
          mediaDetails {
            sizes {
              sourceUrl
              name
            }
          }
        }
        image2 {
          sourceUrl
          mediaDetails {
            sizes {
              sourceUrl
              name
            }
          }
        }
        image3 {
          sourceUrl
          mediaDetails {
            sizes {
              sourceUrl
              name
            }
          }
        }
        image4 {
          sourceUrl
          mediaDetails {
            sizes {
              sourceUrl
              name
            }
          }
        }
        image5 {
          sourceUrl
          mediaDetails {
            sizes {
              sourceUrl
              name
            }
          }
        }
        image6 {
          sourceUrl
          mediaDetails {
            sizes {
              sourceUrl
              name
            }
          }
        }
        image7 {
          sourceUrl
          mediaDetails {
            sizes {
              sourceUrl
              name
            }
          }
        }
        image8 {
          sourceUrl
          mediaDetails {
            sizes {
              sourceUrl
              name
            }
          }
        }
        image9 {
          sourceUrl
          mediaDetails {
            sizes {
              sourceUrl
              name
            }
          }
        }
        image10 {
          sourceUrl
          mediaDetails {
            sizes {
              sourceUrl
              name
            }
          }
        }
        image11 {
          sourceUrl
          mediaDetails {
            sizes {
              sourceUrl
              name
            }
          }
        }
        image12 {
          sourceUrl
          mediaDetails {
            sizes {
              sourceUrl
              name
            }
          }
        }
        image13 {
          sourceUrl
          mediaDetails {
            sizes {
              sourceUrl
              name
            }
          }
        }
        image14 {
          sourceUrl
          mediaDetails {
            sizes {
              sourceUrl
              name
            }
          }
        }
        image15 {
          sourceUrl
          mediaDetails {
            sizes {
              sourceUrl
              name
            }
          }
        }
        image16 {
          sourceUrl
          mediaDetails {
            sizes {
              sourceUrl
              name
            }
          }
        }
        image17 {
          sourceUrl
          mediaDetails {
            sizes {
              sourceUrl
              name
            }
          }
        }
        image18 {
          sourceUrl
          mediaDetails {
            sizes {
              sourceUrl
              name
            }
          }
        }
        image19 {
          sourceUrl
          mediaDetails {
            sizes {
              sourceUrl
              name
            }
          }
        }
        image20 {
          sourceUrl
          mediaDetails {
            sizes {
              sourceUrl
              name
            }
          }
        }
        carPrice
        totalPrice
        capacity
        modelYear
        mileage
        vehicleInspection
        sold
        repairHistory
      }
    }
  }

  soldStocks: stocks(
    first: 200,
    where: {
      orderby: {
        field: DATE,
        order: DESC
      },
      metaQuery: {
        metaArray: {
          key: "sold",
          value: "1"
        }
      }
    }
  ) {
    nodes {
      id
      databaseId
      slug
      date
      title(format: RENDERED)
      carCategories {
        nodes {
          slug
          name
        }
      }
      makers {
        nodes {
          slug
          name
        }
      }
      acf {
        carImage {
          sourceUrl
          mediaDetails {
            sizes {
              sourceUrl
              name
            }
          }
        }
        image1 {
          sourceUrl
          mediaDetails {
            sizes {
              sourceUrl
              name
            }
          }
        }
        image2 {
          sourceUrl
          mediaDetails {
            sizes {
              sourceUrl
              name
            }
          }
        }
        image3 {
          sourceUrl
          mediaDetails {
            sizes {
              sourceUrl
              name
            }
          }
        }
        image4 {
          sourceUrl
          mediaDetails {
            sizes {
              sourceUrl
              name
            }
          }
        }
        image5 {
          sourceUrl
          mediaDetails {
            sizes {
              sourceUrl
              name
            }
          }
        }
        image6 {
          sourceUrl
          mediaDetails {
            sizes {
              sourceUrl
              name
            }
          }
        }
        image7 {
          sourceUrl
          mediaDetails {
            sizes {
              sourceUrl
              name
            }
          }
        }
        image8 {
          sourceUrl
          mediaDetails {
            sizes {
              sourceUrl
              name
            }
          }
        }
        image9 {
          sourceUrl
          mediaDetails {
            sizes {
              sourceUrl
              name
            }
          }
        }
        image10 {
          sourceUrl
          mediaDetails {
            sizes {
              sourceUrl
              name
            }
          }
        }
        image11 {
          sourceUrl
          mediaDetails {
            sizes {
              sourceUrl
              name
            }
          }
        }
        image12 {
          sourceUrl
          mediaDetails {
            sizes {
              sourceUrl
              name
            }
          }
        }
        image13 {
          sourceUrl
          mediaDetails {
            sizes {
              sourceUrl
              name
            }
          }
        }
        image14 {
          sourceUrl
          mediaDetails {
            sizes {
              sourceUrl
              name
            }
          }
        }
        image15 {
          sourceUrl
          mediaDetails {
            sizes {
              sourceUrl
              name
            }
          }
        }
        image16 {
          sourceUrl
          mediaDetails {
            sizes {
              sourceUrl
              name
            }
          }
        }
        image17 {
          sourceUrl
          mediaDetails {
            sizes {
              sourceUrl
              name
            }
          }
        }
        image18 {
          sourceUrl
          mediaDetails {
            sizes {
              sourceUrl
              name
            }
          }
        }
        image19 {
          sourceUrl
          mediaDetails {
            sizes {
              sourceUrl
              name
            }
          }
        }
        image20 {
          sourceUrl
          mediaDetails {
            sizes {
              sourceUrl
              name
            }
          }
        }
        carPrice
        totalPrice
        capacity
        modelYear
        mileage
        vehicleInspection
        sold
        repairHistory
      }
    }
  }
}`;
export function SINGLE(id) {
  return `{
    stock(
      id: "${id}",
      idType: DATABASE_ID
    ) {
      id
      databaseId
      slug
      date
      title(format: RENDERED)
      content(format: RENDERED)
      carCategories {
        nodes {
          slug
          name
        }
      }
      makers {
        nodes {
          slug
          name
        }
      }
      acf {
        carImage {
          sourceUrl
          mediaDetails {
            sizes {
              sourceUrl
              name
            }
          }
        }
        image1 {
          sourceUrl
          mediaDetails {
            sizes {
              sourceUrl
              name
            }
          }
        }
        image2 {
          sourceUrl
          mediaDetails {
            sizes {
              sourceUrl
              name
            }
          }
        }
        image3 {
          sourceUrl
          mediaDetails {
            sizes {
              sourceUrl
              name
            }
          }
        }
        image4 {
          sourceUrl
          mediaDetails {
            sizes {
              sourceUrl
              name
            }
          }
        }
        image5 {
          sourceUrl
          mediaDetails {
            sizes {
              sourceUrl
              name
            }
          }
        }
        image6 {
          sourceUrl
          mediaDetails {
            sizes {
              sourceUrl
              name
            }
          }
        }
        image7 {
          sourceUrl
          mediaDetails {
            sizes {
              sourceUrl
              name
            }
          }
        }
        image8 {
          sourceUrl
          mediaDetails {
            sizes {
              sourceUrl
              name
            }
          }
        }
        image9 {
          sourceUrl
          mediaDetails {
            sizes {
              sourceUrl
              name
            }
          }
        }
        image10 {
          sourceUrl
          mediaDetails {
            sizes {
              sourceUrl
              name
            }
          }
        }
        image11 {
          sourceUrl
          mediaDetails {
            sizes {
              sourceUrl
              name
            }
          }
        }
        image12 {
          sourceUrl
          mediaDetails {
            sizes {
              sourceUrl
              name
            }
          }
        }
        image13 {
          sourceUrl
          mediaDetails {
            sizes {
              sourceUrl
              name
            }
          }
        }
        image14 {
          sourceUrl
          mediaDetails {
            sizes {
              sourceUrl
              name
            }
          }
        }
        image15 {
          sourceUrl
          mediaDetails {
            sizes {
              sourceUrl
              name
            }
          }
        }
        image16 {
          sourceUrl
          mediaDetails {
            sizes {
              sourceUrl
              name
            }
          }
        }
        image17 {
          sourceUrl
          mediaDetails {
            sizes {
              sourceUrl
              name
            }
          }
        }
        image18 {
          sourceUrl
          mediaDetails {
            sizes {
              sourceUrl
              name
            }
          }
        }
        image19 {
          sourceUrl
          mediaDetails {
            sizes {
              sourceUrl
              name
            }
          }
        }
        image20 {
          sourceUrl
          mediaDetails {
            sizes {
              sourceUrl
              name
            }
          }
        }
        carPrice
        totalPrice
        capacity
        modelYear
        mileage
        vehicleInspection
        sold
        repairHistory
        dealer
        new
        parallel
        at
        mtMode
        mt
        carNav
        tv
        dvd
        keyLess
        smartKey
        monitor
        etc
        heat
        sheetAc
        leather
        idling
        sensor
        cruise
        abs
        airbag
        antiTheft
        camera
        foil
        oneOwner
        noSmoking
        record
      }
    }

    news(
      first: 4,
      where: {
        orderby: {
          field: DATE,
          order: DESC
        }
      }
    ) {
      nodes {
        id
        databaseId
        slug
        date
        title(format: RENDERED)
        featuredImage {
          node {
            sourceUrl
            mediaDetails {
              sizes {
                sourceUrl
                name
              }
            }
          }
        }
      }
    }

    stocks(
      first: 4,
      where: {
        orderby: {
          field: DATE,
          order: DESC
        },
        metaQuery: {
          metaArray: {
            key: "sold",
            value: "0"
          }
        }
      }
    ) {
      nodes {
        id
        databaseId
        slug
        date
        title(format: RENDERED)
        carCategories {
          nodes {
            slug
            name
          }
        }
        makers {
          nodes {
            slug
            name
          }
        }
        acf {
          carImage {
            sourceUrl
            mediaDetails {
              sizes {
                sourceUrl
                name
              }
            }
          }
          image1 {
            sourceUrl
            mediaDetails {
              sizes {
                sourceUrl
                name
              }
            }
          }
          image2 {
            sourceUrl
            mediaDetails {
              sizes {
                sourceUrl
                name
              }
            }
          }
          image3 {
            sourceUrl
            mediaDetails {
              sizes {
                sourceUrl
                name
              }
            }
          }
          image4 {
            sourceUrl
            mediaDetails {
              sizes {
                sourceUrl
                name
              }
            }
          }
          image5 {
            sourceUrl
            mediaDetails {
              sizes {
                sourceUrl
                name
              }
            }
          }
          image6 {
            sourceUrl
            mediaDetails {
              sizes {
                sourceUrl
                name
              }
            }
          }
          image7 {
            sourceUrl
            mediaDetails {
              sizes {
                sourceUrl
                name
              }
            }
          }
          image8 {
            sourceUrl
            mediaDetails {
              sizes {
                sourceUrl
                name
              }
            }
          }
          image9 {
            sourceUrl
            mediaDetails {
              sizes {
                sourceUrl
                name
              }
            }
          }
        image10 {
          sourceUrl
          mediaDetails {
            sizes {
              sourceUrl
              name
            }
          }
        }
        image11 {
          sourceUrl
          mediaDetails {
            sizes {
              sourceUrl
              name
            }
          }
        }
        image12 {
          sourceUrl
          mediaDetails {
            sizes {
              sourceUrl
              name
            }
          }
        }
        image13 {
          sourceUrl
          mediaDetails {
            sizes {
              sourceUrl
              name
            }
          }
        }
        image14 {
          sourceUrl
          mediaDetails {
            sizes {
              sourceUrl
              name
            }
          }
        }
        image15 {
          sourceUrl
          mediaDetails {
            sizes {
              sourceUrl
              name
            }
          }
        }
        image16 {
          sourceUrl
          mediaDetails {
            sizes {
              sourceUrl
              name
            }
          }
        }
        image17 {
          sourceUrl
          mediaDetails {
            sizes {
              sourceUrl
              name
            }
          }
        }
        image18 {
          sourceUrl
          mediaDetails {
            sizes {
              sourceUrl
              name
            }
          }
        }
        image19 {
          sourceUrl
          mediaDetails {
            sizes {
              sourceUrl
              name
            }
          }
        }
        image20 {
          sourceUrl
          mediaDetails {
            sizes {
              sourceUrl
              name
            }
          }
        }
          carPrice
          totalPrice
          capacity
          modelYear
          mileage
          vehicleInspection
          sold
          repairHistory
        }
      }
    }

    soldStocks: stocks(
      first: 4,
      where: {
        orderby: {
          field: DATE,
          order: DESC
        },
        metaQuery: {
          metaArray: {
            key: "sold",
            value: "1"
          }
        }
      }
    ) {
      nodes {
        id
        databaseId
        slug
        date
        title(format: RENDERED)
        carCategories {
          nodes {
            slug
            name
          }
        }
        makers {
          nodes {
            slug
            name
          }
        }
        acf {
          carImage {
            sourceUrl
            mediaDetails {
              sizes {
                sourceUrl
                name
              }
            }
          }
          image1 {
            sourceUrl
            mediaDetails {
              sizes {
                sourceUrl
                name
              }
            }
          }
          image2 {
            sourceUrl
            mediaDetails {
              sizes {
                sourceUrl
                name
              }
            }
          }
          image3 {
            sourceUrl
            mediaDetails {
              sizes {
                sourceUrl
                name
              }
            }
          }
          image4 {
            sourceUrl
            mediaDetails {
              sizes {
                sourceUrl
                name
              }
            }
          }
          image5 {
            sourceUrl
            mediaDetails {
              sizes {
                sourceUrl
                name
              }
            }
          }
          image6 {
            sourceUrl
            mediaDetails {
              sizes {
                sourceUrl
                name
              }
            }
          }
          image7 {
            sourceUrl
            mediaDetails {
              sizes {
                sourceUrl
                name
              }
            }
          }
          image8 {
            sourceUrl
            mediaDetails {
              sizes {
                sourceUrl
                name
              }
            }
          }
          image9 {
            sourceUrl
            mediaDetails {
              sizes {
                sourceUrl
                name
              }
            }
          }
        image10 {
          sourceUrl
          mediaDetails {
            sizes {
              sourceUrl
              name
            }
          }
        }
        image11 {
          sourceUrl
          mediaDetails {
            sizes {
              sourceUrl
              name
            }
          }
        }
        image12 {
          sourceUrl
          mediaDetails {
            sizes {
              sourceUrl
              name
            }
          }
        }
        image13 {
          sourceUrl
          mediaDetails {
            sizes {
              sourceUrl
              name
            }
          }
        }
        image14 {
          sourceUrl
          mediaDetails {
            sizes {
              sourceUrl
              name
            }
          }
        }
        image15 {
          sourceUrl
          mediaDetails {
            sizes {
              sourceUrl
              name
            }
          }
        }
        image16 {
          sourceUrl
          mediaDetails {
            sizes {
              sourceUrl
              name
            }
          }
        }
        image17 {
          sourceUrl
          mediaDetails {
            sizes {
              sourceUrl
              name
            }
          }
        }
        image18 {
          sourceUrl
          mediaDetails {
            sizes {
              sourceUrl
              name
            }
          }
        }
        image19 {
          sourceUrl
          mediaDetails {
            sizes {
              sourceUrl
              name
            }
          }
        }
        image20 {
          sourceUrl
          mediaDetails {
            sizes {
              sourceUrl
              name
            }
          }
        }
          carPrice
          totalPrice
          capacity
          modelYear
          mileage
          vehicleInspection
          sold
          repairHistory
        }
      }
    }
  }`;
}
//# sourceMappingURL=query.js.map
